import { getNonce } from 'core/utils/csp-nonce';

const scriptSrcProduction =
  '//assets.adobedtm.com/cfabee345daf36db64390f77e2796157ad14f5fd/satelliteLib-431207587ed9f8a4e20795bca63846c3d1b95845.js';

/**
 * This function injects a script tag into the DOM
 * to let Adobe Analytics' satellite know that the bottom
 * of the page has been loaded - or whatever it needs to know.
 */
function triggerSatellitePageBottomEvent() {
  const script = document.createElement('script');
  script.innerHTML = 'window._satellite.pageBottom();';
  script.defer = true;
  script.async = true;
  script.nonce = getNonce();
  document.body.appendChild(script);
}

/**
 * Build the script tag with a given source and inject it into DOM.
 */
function appendAdobeAnalyticsScript(scriptSrc: string) {
  // Build the script tag.
  const script = document.createElement('script');
  script.src = scriptSrc;
  script.defer = true;
  script.async = true;
  script.type = 'text/plain';
  script.className = 'optanon-category-C0004';
  script.nonce = getNonce();
  // Make sure that the satellite is called after the script has loaded.
  script.onload = triggerSatellitePageBottomEvent;
  // Append to <head>.
  document.head.appendChild(script);
}

/**
 * Inject Adobe Analytics code snippet for production environment.
 */
export function appendAdobeAnalyticsScriptForProduction() {
  appendAdobeAnalyticsScript(scriptSrcProduction);
}
